import AddCircle from "@mui/icons-material/AddCircle";
import React from "react";
import { CurrentSeriesProps } from "components/DataExplorationV2/ConfigureMenu/SeriesSection/CurrentSeries";
import { styled } from "@mui/material/styles";
import { IconButton } from "@mui/material";
import { MenuTooltip } from "components/DataExplorationV2/MenuTooltip";
import { withTransientProps } from "core/utils/transientProps";

export const AddSeries = ({
  series,
  onAddSeries
}: CurrentSeriesProps): JSX.Element => {
  return (
    <CurrentSeriesSubtitle
      $clickable={!!series && series.length >= 5}
      onClick={!!series && series.length >= 5 ? undefined : onAddSeries}
    >
      {"Add series"}
      <MenuTooltip
        title={!!series && series.length >= 5 ? "5 series max" : "Add series"}
      >
        <span>
          <SecondaryButton
            color="secondary"
            aria-label="Add series"
            disabled={!!series && series.length >= 5}
          >
            <AddCircle />
          </SecondaryButton>
        </span>
      </MenuTooltip>
    </CurrentSeriesSubtitle>
  );
};

const SecondaryButton = styled(IconButton)`
  width: 20px;
  height: 20px;
  padding: 0 !important;
  .MuiSvgIcon-root {
    transition: all 150ms ease-out;
    &:hover {
      color: #19173f !important;
      opacity: 0.8;
    }
  }
`;

const CurrentSeriesSubtitle = styled("div", withTransientProps)<{
  $clickable: boolean;
}>`
  display: flex;
  margin: 0 0 ${({ theme }) => theme.spacing(1)};
  font-size: 0.75rem;
  align-items: center;
  justify-content: space-between;
  cursor: ${props => (props.$clickable === false ? "pointer" : "default")};
`;
